import { SentryErrorFeedbackForm } from "./sentry-error-feedback-form";

export function SentryErrorFeedback({ eventId }: { eventId?: string | null }) {
  if (!eventId) {
    return null;
  }

  return <SentryErrorFeedbackForm eventId={eventId} />;
}
